import React from 'react';
import PropTypes from 'prop-types';

import Button from '../../common/Button';
import Modal from '../../common/Modal';
import Message from '../../common/Message';
import SendReferralLinkForm from './Form';

const SendReferralLinkModal = ({
  buttonLabel,
  buttonMode,
  buttonSize,
  buttonBlock,
  message,
  blockParentForm,
  unblockParentForm,
  referredByUserId,
  successAction,
}) => {
  const [modalIsOpen, setModalIsOpen] = React.useState(false);

  const openModal = () => {
    setModalIsOpen(true);
    if (blockParentForm) unblockParentForm();
  };

  const closeModal = () => {
    setModalIsOpen(false);
    if (unblockParentForm) unblockParentForm();
  };

  return (
    <>
      <Button
        size={buttonSize}
        mode={buttonMode}
        label={buttonLabel}
        block={buttonBlock}
        onClick={() => openModal()}
      />
      <Modal
        heading="Refer a friend"
        isOpen={modalIsOpen}
        closeAction={() => closeModal()}
        contentLabel="Refer a friend"
      >
        <SendReferralLinkForm
          referredByUserId={referredByUserId}
          successAction={() => {
            if (successAction) successAction();
            closeModal();
          }}
          cancelAction={closeModal}
        />
        <br />
        {message && <Message>{message}</Message>}
      </Modal>
    </>
  );
};

SendReferralLinkModal.propTypes = {
  referredByUserId: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string,
  buttonMode: PropTypes.string,
  buttonSize: PropTypes.string,
  buttonBlock: PropTypes.bool,
  blockParentForm: PropTypes.func,
  unblockParentForm: PropTypes.func,
  message: PropTypes.string,
  successAction: PropTypes.func,
};

SendReferralLinkModal.defaultProps = {
  buttonLabel: 'Refer a friend',
  buttonMode: 'primary',
  buttonSize: 'm',
  buttonBlock: false,
  blockParentForm: undefined,
  unblockParentForm: undefined,
  message: undefined,
  successAction: undefined,
};

export default SendReferralLinkModal;
